import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';

/** Posta no <html> pelo script data-agj-desktop-boot (src/index.html) em aparelho que não é celular */
export const DESKTOP_MODE_CLASS = 'agj-desktop-mode-on';
/** $notebook do One (styles/responsive.scss): abaixo disso fica o layout de celular */
export const DESKTOP_MIN_WIDTH = 768;
/**
 * Celular pelo user agent. A MESMA expressão está no script data-agj-desktop-boot (src/index.html): manter as duas
 * iguais. iPad (que se diz Mac desde o iPadOS 13) e tablet Android (sem "Mobile") ficam de fora: são desktop
 */
export const PHONE_USER_AGENT = /iPhone|iPod|Android.+Mobile|Windows Phone|IEMobile|BlackBerry|BB10|Opera Mini/i;

/**
 * Modo desktop (tablet e computador; pedido do dono), espelho do mixin desktop.on (src/styles/tools/_desktop.scss)
 * para o que o CSS não alcança: valendo só com a classe do boot e a janela larga. No servidor e no celular, falso.
 */
@Injectable({ providedIn: 'root' })
export class DesktopModeService {
  private readonly document = inject(DOCUMENT);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  public readonly enabled = signal(false);

  constructor() {
    const win = this.document.defaultView;
    if (!this.isBrowser || !win?.matchMedia) return;

    const query = win.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`);
    const update = (): void => this.enabled.set(this.document.documentElement.classList.contains(DESKTOP_MODE_CLASS) && query.matches);
    update();
    // addEventListener no MediaQueryList só existe a partir do Safari 14; antes disso vale a leitura inicial
    query.addEventListener?.('change', update);
  }
}
